module.exports = {"id":"198717","name":"Wilfried Zaha","rating":"82","photo":"./data/images/photos/1/198717.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["MG","BU","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WilfriedZaha0.json
// module id = 4338
// module chunks = 0